import Ulangan from '../../../views/Kurikulum/Ulangan/Ulangan.view';

export default Ulangan;